import { useCallback, useMemo, useState } from 'react';
import {
  getCurrentResortData,
  getLocationList,
  getResortLocationUrl,
  getResortShortName,
  storeLocationList
} from '../../utilities/lodgeData';

export default function useLodgeData() {
  const resortLocationUrl = getResortLocationUrl();
  const resortShortName = getResortShortName();

  const [locationList, setLocationList] = useState(getLocationList());

  // Current lodge data that is needed is provided on state by getCurrentResortData function
  // any new value should be updated on state by getCurrentResortData function
  const [{ resortDisplay, resortPhone, resortAddress, resortDailyParkingFee }] = useState(getCurrentResortData());

  const updateLocationList = useCallback(locationList => {
    const builtLocationList = locationList.reduce((prev, current) => {
      return {
        ...prev,
        [current.id]: {
          address: current.Address,
          booking_phone: current.PhoneNumber,
          display: current.Name,
          shortDisplayName: current.Name,
          mobile_booking_phone: current.MobileBookingPhone,
          phone: current.PhoneNumber,
          operaCode: current.id,
          url: current.ShortName,
          region: current.Region,
          birthdayEmail: current.BirthdayEmail,
          maxOccupancy: current.MaxOccupancy,
          dailyParkingFee: current.dailyParkingFee
        }
      };
    }, {});
    storeLocationList(builtLocationList);
    setLocationList(builtLocationList);
  }, []);

  const locationsByRegion = useMemo(() => {
    const locationsByRegion = [];
    const regionMap = {};

    Object.values(locationList || {}).forEach(location => {
      const { display, region: regionName, operaCode } = location;
      if (!regionMap[regionName]) {
        regionMap[regionName] = { regionName, locations: [] };
        locationsByRegion.push(regionMap[regionName]);
      }
      regionMap[regionName].locations.push({
        display,
        region: regionName,
        operaCode
      });
    });

    return locationsByRegion;
  }, [locationList]);

  const getLocationDataByResortCode = useCallback(
    resortCode => {
      return locationList[resortCode] || {};
    },
    [locationList]
  );

  return {
    locationList,
    updateLocationList,
    locationsByRegion,
    getLocationDataByResortCode,
    resortLocationUrl,
    resortShortName,
    resortDisplay,
    resortPhone,
    resortAddress,
    resortDailyParkingFee
  };
}
